<template>
  <div class="oder-box">
    <div class="ob-code">
      <span>编号：{{detail.code}}</span>
    </div>
    <div class="ob-express" v-if="detail.express">
      <div>快递：{{detail.expressDesc}}</div>
      <div>单号：{{detail.expressCode}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    detail:{
      type:Object,
      required:true
    }
  },
  name: "order-box",
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>

<style lang="less" scoped>
.oder-box{
  .ob-code{
    height: 20px;
    line-height: 20px;
  }

  .ob-express{
    div{
      height: 20px;
      line-height: 20px;
    }
  }
}
</style>
